import { SxProps, Theme } from '@mui/material/styles'
import { C1Icon } from 'components/core/icons/C1Icon'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { CircleCheck, Info, Pencil, PieChart } from 'lucide-react'
import React from 'react'
import { styles } from './styles'

type AccessReviewStatusIconProps = {
    className?: string
    iconSize?: 'small' | 'inherit' | 'medium' | 'large'
    sx?: SxProps<Theme>
}

const mapIconSize = (iconSize?: 'small' | 'inherit' | 'medium' | 'large'): 'sm' | 'md' | 'lg' | undefined => {
    switch (iconSize) {
        case 'small':
            return 'sm'
        case 'medium':
        case 'inherit':
            return 'md'
        case 'large':
            return 'lg'
        default:
            return undefined
    }
}

export const AccessReviewStateFacetIconOpen = ({ className, iconSize, sx }: AccessReviewStatusIconProps): React.ReactElement => {
    const iconSx = sx ?? styles.icon
    return <C1Icon icon={PieChart} size={mapIconSize(iconSize)} aria-label="open" className={className} sx={sxc(iconSx, styles.open)} />
}

export const AccessReviewStateFacetIconPending = ({
    className,
    iconSize,
    sx,
}: AccessReviewStatusIconProps): React.ReactElement => {
    const iconSx = sx ?? styles.icon
    return <C1Icon icon={Pencil} size={mapIconSize(iconSize)} aria-label="pending" className={className} sx={sxc(iconSx, styles.purple)} />
}

export const AccessReviewStateFacetIconUnspecified = ({
    className,
    iconSize,
    sx,
}: AccessReviewStatusIconProps): React.ReactElement => {
    const iconSx = sx ?? styles.icon
    return (
        <C1Icon icon={Info} size={mapIconSize(iconSize)} aria-label="unspecified" className={className} sx={sxc(iconSx, styles.unspecified)} />
    )
}

export const AccessReviewStateFacetIconClosed = ({ className, iconSize, sx }: AccessReviewStatusIconProps): React.ReactElement => {
    const iconSx = sx ?? styles.icon
    return <C1Icon icon={CircleCheck} size={mapIconSize(iconSize)} aria-label="closed" className={className} sx={sxc(iconSx, styles.purple)} />
}
